<template>
  <div class="big chufang-detail">
    <div class="page_title flex_between">
      <span> 患者售后申请详情</span>
      <span>
        <el-button plain
                   style="width: 92px"
                   size="medium"
                   @click="back">返回</el-button>
      </span>
    </div>
    <div style="padding: 20px">
      <div class="container">
        <el-divider content-position="left"
                    class="subhead">售后基本信息</el-divider>
        <div class="basic-info">
          <div class="top">
            <!-- 订单号 -->
            <div class="item">
              <span class="title">订单号</span>
              <span> {{ detail.order_sn }}</span>
              <el-button v-if="detail.is_exit == 1"
                         type="primary"
                         size="mini"
                         @click="toDetail(1, detail.order_id)"
                         style="margin-left: 4px">查看订单详情</el-button>
            </div>
            <!-- 患者姓名 -->
            <div class="item">
              <span class="title">患者姓名</span>
              <span>{{ detail.user_name }}</span>
              <el-button type="primary"
                         size="mini"
                         @click="toDetail(2, detail.user_id)"
                         style="margin-left: 4px">查看用户详情</el-button>
            </div>
            <!-- 联系电话 -->
            <div class="item">
              <span class="title">联系电话</span>
              <span> {{ detail.phone }} </span>
            </div>
            <!-- 售后原因 -->
            <div class="item">
              <span class="title">售后原因</span>
              <span> {{ detail.refund_desc }} </span>
            </div>
            <!-- 补充描述 -->
            <div class="item">
              <span class="title">补充描述</span>
              <span> {{ detail.remark }} </span>
            </div>
          </div>
          <div class="bottom">
            <div style="margin: 15px 0 10px">
              <span class="title">凭证</span>
            </div>
            <div>
              <div style="margin-bottom: 10px">快递包装图</div>
              <el-image style="height: 100px; width: 100px; margin-right: 20px"
                        :src="item"
                        :preview-src-list="express_pic"
                        v-for="(item, index) in express_pic"
                        :key="index">
              </el-image>
            </div>
            <div>
              <div style="margin-bottom: 10px">药品包装图</div>
              <el-image style="height: 100px; width: 100px; margin-right: 20px"
                        :src="item"
                        :preview-src-list="drug_box_pic"
                        v-for="(item, index) in drug_box_pic"
                        :key="index">
              </el-image>
            </div>
          </div>
        </div>
        <el-divider content-position="left"
                    class="subhead">处理意见
        </el-divider>

        <div class="handling-suggestion">
          <template v-if="!detail.advice">
            <el-tabs v-model="activeName"
                     @tab-click="handleClick">
              <el-tab-pane label="无需处理"
                           name="1">
                <el-input maxlength="200"
                          style="width: 800px"
                          type="textarea"
                          :rows="8"
                          placeholder="请输入内容"
                          v-model="detail.customer_service_remark"
                          show-word-limit
                          :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('763')
                      : false
                  ">
                </el-input>
                <el-button type="primary"
                           style="margin-left: 10px"
                           size="medium"
                           @click="saveRemark"
                           :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('763')
                      : false
                  ">确 定</el-button>
              </el-tab-pane>
              <el-tab-pane label="售后退款"
                           :disabled="
                  module_id_array[0] ? !module_id_array.includes('1572') : false
                "
                           name="2">
                <!-- 售后退款 -->
                <RefundAfterSale :refundAfterSaleDia.sync="refundAfterSaleDia"
                                 :detail="detail"
                                 @comfirmRefundAfterSale="comfirmRefundAfterSale"></RefundAfterSale>
                <div class="prompt"
                     style="font-size: 16px">
                  {{ errorText }}
                </div>
              </el-tab-pane>
              <el-tab-pane label="作废退款"
                           :disabled="
                  module_id_array[0] ? !module_id_array.includes('1573') : false
                "
                           name="3">
                <!-- 作废退款 -->
                <OrderRefund :orderRefundDia.sync="orderRefundDia"
                             :refund_data="detail"
                             @comfirmOrderRefund="comfirmOrderRefund"></OrderRefund>
                <div class="prompt"
                     style="font-size: 16px">
                  {{ errorText }}
                </div>
              </el-tab-pane>
              <el-tab-pane label="申请补发"
                           :disabled="
                  module_id_array[0] ? !module_id_array.includes('1574') : false
                "
                           name="4">
                <!-- 申请补发 -->
                <template v-if="errorText == ''">
                  <AupplyAgain :refund_data="detail"
                               @comfirmAupplyAgain="comfirmAupplyAgain"></AupplyAgain>
                </template>
                <div class="prompt"
                     style="font-size: 16px">
                  {{ errorText }}
                </div>
              </el-tab-pane>
            </el-tabs>
          </template>

          <template v-else>
            <div style="margin-bottom: 10px">{{ detail.type | typeText }}</div>
            <template v-if="detail.type == 1">
              <div>备注：{{ detail.advice.remark }}</div>
            </template>

            <template v-if="detail.type == 2 || detail.type == 3">
              <div style="margin-bottom: 10px">
                退款原因：{{ detail.advice.refund_desc }}
              </div>
              <div style="margin-bottom: 10px">
                退款金额：{{ detail.advice.refund_money }}
              </div>
              <div>备注：{{ detail.advice.remark }}</div>
            </template>

            <template v-if="detail.type == 4">
              <div style="margin-bottom: 10px">
                补发类型：{{ detail.advice.again_type }}
              </div>
              <div style="margin-bottom: 10px">
                补发备注：{{ detail.advice.again_remark }}
              </div>
              <div style="margin-bottom: 10px">
                补发原因：{{ detail.advice.again_reason | againReasonText }}
              </div>
              <div style="margin-bottom: 10px">
                补发状态：{{ detail.advice.status == 1 ? "已补发" : "待补发" }}
              </div>
              <div style="margin-bottom: 10px">
                补发药品：{{ detail.advice.drug_list | drugListText }}
              </div>
              <div class="aupply-again-express"
                   v-if="detail.advice.delivery">
                <div>配送信息：</div>
                <div class="info">
                  <div class="item">
                    配送方式：{{ detail.advice.delivery | deliveryText }}
                  </div>
                  <template v-if="detail.advice.delivery != 2">
                    <div class="item">
                      快递公司：{{ detail.advice.express_name }}
                    </div>
                    <div class="item">
                      运单号：{{ detail.advice.express_no }}
                      <el-button type="primary"
                                 size="mini"
                                 @click="lookExpress"
                                 style="margin-left: 4px">查看物流</el-button>
                    </div>
                    <div class="item">
                      收货信息：{{
                        detail.advice.address_info | addressInfoText
                      }}
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
    <!-- 物流详情弹窗 -->
    <el-dialog title="查看物流"
               :visible.sync="expressVisible"
               width="800px"
               style="text-align: left"
               :close-on-click-modal="false">
      <div>
        <div style="padding: 24px 30px 20px 70px">
          <div>
            <span style="color: #666">快递公司：</span>
            <span>{{ express_data.express_name }}</span>
          </div>
          <div style="margin: 10px 0">
            <span style="color: #666">运单号：</span>
            <span>{{ express_data.express_no }}</span>
          </div>
          <div style="margin-bottom: 30px">
            <span style="color: #666">联系电话：</span>
            <span>{{ express_data.express_phone }}</span>
          </div>

          <el-timeline>
            <el-timeline-item v-for="(item, index) in express_data.list"
                              :key="index"
                              :icon="item.icon"
                              :type="item.type"
                              :color="item.color"
                              :size="item.size"
                              :timestamp="item.time">
              {{ item.content }}</el-timeline-item>
          </el-timeline>
        </div>
        <div style="text-align: right; padding: 0 20px 20px 0">
          <el-button type="primary"
                     @click="expressVisible = false"
                     style="width: 92px">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import RefundAfterSale from '@/components/common/RefundAfterSale.vue';
import OrderRefund from '@/components/common/OrderRefund.vue';
import AupplyAgain from '@/components/common/AupplyAgain.vue';
import order from '@/api/order';
export default {
  components: {
    RefundAfterSale,
    OrderRefund,
    AupplyAgain
  },
  data() {
    return {
      detail: {},
      drug_box_pic: [],
      express_pic: [],
      activeName: '1',
      refundAfterSaleDia: false,
      orderRefundDia: false,
      errorText: '',
      expressVisible: false,
      express_data: {}
    };
  },
  filters: {
    typeText(val) {
      switch (val) {
        case 1:
          return '无须处理';
        case 2:
          return '售后退款';
        case 3:
          return '作废退款';
        case 4:
          return '申请补发';
        default:
          return '';
      }
    },
    againReasonText(val) {
      switch (val) {
        case 1:
          return '漏发（不扣减库存）';
        case 2:
          return '分批次（不扣减库存）';
        case 3:
          return '破损（扣减库存及用量）';
        default:
          return '';
      }
    },
    deliveryText(val) {
      switch (val) {
        case 1:
          return '快递';
        case 2:
          return '自提';
        case 3:
          return '闪送';
        default:
          return '';
      }
    },
    drugListText(val) {
      let arr = val.map((item) => {
        let nationalText = item.is_national_standard == 1 ? '（新）' : '';
        let use_level =
          item.is_national_standard == 1
            ? item.national_standard_level
            : item.item_use_level;
        return `${item.generic_name}${nationalText}/${use_level}${item.item_unit}`;
      });
      return arr.join(',');
    },
    addressInfoText(val) {
      return `${val.consignee_phone}/${val.province_name}/${val.city_name}/${val.district_name}/${val.address}`;
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //查看物流信息
    lookExpress() {
      let again_id = this.detail.advice.again_id;
      const loading = this.$loading();
      order
        .orderAgainExpress({ again_id })
        .then((res) => {
          if (res.code == 0) {
            this.express_data = res.data.info;
            this.expressVisible = true;
            this.express_data.list[0].type = 'primary';
            this.express_data.list[0].size = 'large';
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //获取详情
    getDetail() {
      const loading = this.$loading();
      let id = this.$route.query.id;
      this.axios
        .post('platform/order/getOrderServiceInfo', { id })
        .then((res) => {
          if (res.code == 0) {
            this.detail = res.data.info;
            this.drug_box_pic = res.data.info.drug_box_pic.split(',');
            this.express_pic = res.data.info.express_pic.split(',');
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //保存备注
    saveRemark() {
      if (!this.detail.customer_service_remark) {
        this.$message.error('请先填写备注');
        return false;
      }
      let data = {
        id: this.$route.query.id,
        customer_service_remark: this.detail.customer_service_remark
      };
      this.axios
        .post('platform/order/saveOrderServiceInfo', data)
        .then((res) => {
          this.$message.success('保存成功');
          this.getDetail();
        });
    },
    // 查看详情
    toDetail(type, id) {
      let path = '';
      let query = {};
      switch (type) {
        case 1:
          path = '/home/order/orderdetail';
          query = {
            order_id: id
          };
          break;

        case 2:
          path = '/home/patient/userdetail';
          query = {
            user_id: id
          };
          break;
      }
      this.$router.push({
        path,
        query
      });
    },
    handleClick(val) {
      switch (val.name) {
        case '1':
          break;
        case '2':
          if (
            this.detail.examination_abnormal == 1 ||
            this.detail.refund_abnormal == 1 ||
            this.detail.order_status == 5 ||
            this.detail.order_status == 6 ||
            !this.detail.is_exit
          ) {
            this.errorText = '当前订单不存在或不可发起售后退款';
            return;
          }
          this.refundAfterSaleDia = true;
          this.errorText = '';
          break;
        case '3':
          if (
            !this.detail.is_exit ||
            this.detail.order_status == 5 ||
            this.detail.order_status == 6 ||
            this.detail.is_abnormal == 1 ||
            this.detail.examination_abnormal == 1 ||
            this.detail.refund_abnormal == 1
          ) {
            this.errorText = '当前订单状态不存在或不可发起作废退款';
            return;
          }
          this.orderRefundDia = true;
          this.errorText = '';
          break;
        case '4':
          console.log(!this.detail.is_exit);
          if (
            !this.detail.is_exit ||
            this.detail.order_status == 2 ||
            this.detail.order_status == 5 ||
            this.detail.order_status == 6 ||
            this.detail.is_abnormal == 1 ||
            this.detail.examination_abnormal == 1 ||
            this.detail.refund_abnormal == 1
          ) {
            this.errorText = '当前订单状态不存在或不可发起申请补发';
            return;
          }
          this.errorText = '';
          break;
      }
    },
    // 售后退款
    comfirmRefundAfterSale() {
      this.getDetail();
    },
    // 作废退款
    comfirmOrderRefund() {
      this.getDetail();
    },
    // 申请补发
    comfirmAupplyAgain() {
      this.getDetail();
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  border-radius: 5px;
  text-align: left;
}
.inbobox {
  display: flex;
  margin-bottom: 20px;
  height: 90px;
  .inboitem {
    padding: 14px 50px 14px 20px;
    box-sizing: border-box;
    margin-right: 20px;
    background-color: #f9f8ee;
    border: solid 1px #dad8ca;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .infotitle {
      width: 90px;
      display: inline-block;
    }
  }
}
.title {
  font-size: 15px;
  font-weight: 700;
  display: inline-block;
  width: 120px;
  text-align: right;
  margin-right: 30px;
}
.subhead {
  .el-divider__text {
    font-size: 16px;
    font-weight: bold;
  }
}
.basic-info {
  .top {
    display: flex;
    align-items: center;
    .item {
      display: flex;
      align-items: center;
    }
  }
  .bottom {
    display: flex;
    align-items: baseline;
  }
}
.handling-suggestion {
  padding-left: 40px;
}
.aupply-again-express {
  .info {
    padding: 10px 0 0 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .item {
      min-width: 160px;
    }
  }
}
</style>
